import axios from 'axios';
import { ADMIN_BASE } from './utils/adminBase';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('sankyo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    // An expired/invalid session bounces to the login page — but not a
    // failed login attempt itself, which would reload the login page and
    // wipe the error message before the user could read it.
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('sankyo_token');
      window.location.href = `${ADMIN_BASE}/login`;
    }
    return Promise.reject(err);
  }
);

// A random id this browser keeps in localStorage, generated once and reused
// forever after — lets the backend count unique visitors (COUNT DISTINCT)
// instead of raw page loads. Not tied to any personal info, just an anonymous
// per-browser tag; cleared if the visitor clears site data, same as a cookie.
function getVisitorId() {
  const KEY = 'sankyo_visitor_id';
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null; // private browsing / storage blocked — view still counts, just not as a unique visitor
  }
}

// Fire-and-forget view tracking — never awaited, never lets a failure
// surface anywhere, since a dropped analytics ping should never affect the
// visitor's actual experience of the page.
export function trackView(type, id) {
  if (!id) return;
  API.post('/views', { type, id, visitorId: getVisitorId() }).catch(() => {});
}

export default API;
